// how-to-use-slider.js - Optimized video loading
if (!customElements.get('htu-slider-component')) {
  customElements.define('htu-slider-component', class HTUSlider extends HTMLElement {
    constructor() {
      super();
      this.loadedVideos = new Set();
    }

    connectedCallback() {
      this.slider = this.querySelector('.htu-slider');
      this.slides = this.querySelectorAll('.htu-slide');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.counterCurrent = this.querySelector('.slider-counter--current');

      this.initButtons();
      this.initIntersectionObserver();
    }

    initButtons() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          const scrollAmount = this.slider.offsetWidth;
          this.slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          const scrollAmount = this.slider.offsetWidth;
          this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }
    }

    initIntersectionObserver() {
      const observerOptions = {
        root: this.slider,
        threshold: 0.5
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const slideIndex = entry.target.getAttribute('data-slide-index');
            if (this.counterCurrent) {
              this.counterCurrent.textContent = slideIndex;
            }

            // Play video in current slide
            const video = entry.target.querySelector('video');
            const videoContainer = entry.target.querySelector('.htu-video-container');
            if (video) {
              this.loadAndPlayVideo(video, videoContainer);
            }
          } else {
            // Pause and reset video when slide is not visible
            const video = entry.target.querySelector('video');
            if (video) {
              video.pause();
              video.currentTime = 0;
            }
          }
        });
      }, observerOptions);

      this.slides.forEach((slide) => observer.observe(slide));
    }

    loadAndPlayVideo(video, videoContainer) {
      if (!video) return;

      const videoId = video.getAttribute('src') || video.querySelector('source')?.getAttribute('src');

      // If already loaded and ready, just restart
      if (this.loadedVideos.has(videoId) && video.readyState >= 3) {
        video.currentTime = 0;
        video.play().catch((error) => console.log('Video play failed:', error));
        return;
      }

      this.showLoader(videoContainer);

      const onLoadedData = () => {
        this.hideLoader(videoContainer);
        this.loadedVideos.add(videoId);
        video.play().catch((error) => {
          console.log('Video play failed:', error);
          this.hideLoader(videoContainer);
        });
      };

      const onError = () => {
        console.error('Video failed to load');
        this.hideLoader(videoContainer);
      };

      video.addEventListener('loadeddata', onLoadedData, { once: true });
      video.addEventListener('error', onError, { once: true });

      video.load();
    }

    showLoader(videoContainer) {
      if (videoContainer) {
        videoContainer.classList.add('loading');
      }
    }

    hideLoader(videoContainer) {
      if (videoContainer) {
        videoContainer.classList.remove('loading');
      }
    }
  });
}
